import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useI18n } from "../../lib/i18n";

export const BackButton = ({ fallback = "/" }) => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const handle = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };
  return (
    <button
      type="button"
      onClick={handle}
      className="inline-flex items-center gap-1.5 font-mono text-xs text-neutral-500 hover:text-white transition-colors duration-200"
      data-testid="back-button"
    >
      <ArrowLeft className="h-3.5 w-3.5" strokeWidth={1.5} />
      <span>{t("back_btn")}</span>
    </button>
  );
};
